import Handlers from '../dispatcher/Handlers';
import { ActionTypes } from '../constants/CentricConstants';
import MailLogApi from '../server/MailLogApi';

export default {

    getAll: function(params) {
        const handleSuccess = Handlers.createSuccessHandler(ActionTypes.MAIL_LOG_LIST);
        const handleError = Handlers.createErrorHandler(ActionTypes.MAIL_LOG_LIST_ERROR);

        return MailLogApi.getAll(params)
            .then(handleSuccess, handleError)
            .catch(Handlers._handleException);
    },

};
